import { render, staticRenderFns } from "./PIReport.vue?vue&type=template&id=21c52ad4&"
import script from "./PIReport.vue?vue&type=script&lang=js&"
export * from "./PIReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports